import React, { useEffect, useRef, useState, useContext } from 'react';
import './RaisedNewViolation.css';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import { Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import moment from 'moment';
import { getImpactedTransactionData, getPlaza, validateViolationForRaisedDispute } from '../../../common/apiService';
import MultiSelect from '../../../common/MultiSelect';
import RaiseDisputeScreen from './RaiseDisputeScreen';
import { toast } from 'react-toastify';
import { UserContext } from '../../../contexts/UserContext';

export default function RaisedViolationScreen() {
  const [loading, setLoading] = useState(false);
  const [tollPlazaData, setTollPlaza] = useState([]);
  const [impactedTransaction, setImpactedTransaction] = useState('raiseNewViolation');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [tagId, setTagId] = useState("");
  const [vrn, setVrn] = useState("");
  const [plaza, setPlaza] = useState("");
  const [tmsTxnId, setTmsTxnId] = useState("");
  const [showRaisedVioScreen, setShowRaisedVioScreen] = useState(false);
  const [disputeDetails, setDisputeDetails] = useState({});
  const userDetail = useContext(UserContext);
  const [isCAScreen, setIsCAScreen] = useState(false);
  const [isCAReport, setIsCAReport] = useState(false);
  const [fields, setFields] = useState({
    date: { valid: true, msg: "Please select Date range!" },
    plaza: { valid: true, msg: "Please select plaza!" }
  });
  const [gridData, setGridData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  
  const totalPages = Math.ceil(gridData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = gridData.slice(startIndex, startIndex + itemsPerPage);

  const validateFields = (key, valid) => {
    setFields(old => ({ ...old, [key]: { ...old[key], valid } }));
  };

  const rrnRef = useRef("");


  const setDate = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
      validateFields('date', true);
    } else {
      setStartDate("");
      setEndDate("");
      validateFields('date', false);
    }
  };

  const setPlazaIds = (val) => {
    setPlaza(val);
    if (val.length !== 0)
      validateFields('plaza', true);
    else
      validateFields('plaza', false);
  };

  const dateRangeMaxRange =
    impactedTransaction === "raiseNewViolation" ||
    impactedTransaction === "eligibleForDA"
      ? 3
      : 25;

  const showEligibleforDA= userDetail?.roles?.includes("ROLE_ELIGIBLE_DA");

  useEffect(() => {
    if (impactedTransaction === "eligibleForDA") {
      const today = new Date();
      const minDate = new Date(
        moment(today).subtract(dateRangeMaxRange, "days")
      );
      const headerJson = {
        impactedTransaction,
        startDate: moment(minDate).format("yyyy-MM-DD"),
        endDate: moment(today).format("yyyy-MM-DD"),
        tagId: tagId || "",
        vrn: vrn || "",
        tmsTxnId: tmsTxnId || "",
        rrn: rrnRef.current.value || "",
        field: tagId
          ? "tagId"
          : vrn
          ? "vrn"
          : tmsTxnId
          ? "tmsTxnId"
          : rrnRef.current.value
          ? "rrn"
          : "",
        value: tagId
          ? tagId
          : vrn
          ? vrn
          : tmsTxnId
          ? tmsTxnId
          : rrnRef.current.value
          ? rrnRef.current.value
          : "",
      };
      const requestBody = {
        plazaIds: Array.isArray(plaza) ? plaza.join(",") : plaza,
      };
      setLoading(true);
      //console.log(headerJson);
      getImpactedTransactionData(headerJson, requestBody, impactedTransaction)
        .then((res) => {
          //console.log(res);
          const transformedData = res.data.map((row) => ({
            ...row,
            plazaName:
              impactedTransaction === "raiseNewViolation" ||
              impactedTransaction === "eligibleForDA"
                ? row.plazaName
                : `${row.plazaName.plazaDesc}`,
          }));
          //console.log("ans",transformedData);
          setGridData(transformedData);
          setLoading(false);
        })
        .catch((_err) => {
          console.log("error");
          setGridData([]);
          setLoading(false);
        });
    }
  }, [impactedTransaction]);

  useEffect(() => {
    if (userDetail?.roles !== null) {
      const role = userDetail?.roles;
      setIsCAScreen(role?.includes("ROLE_CA_SCREEN"));
      setIsCAReport(role?.includes("ROLE_CA_REPORT"));
    }
  }, [userDetail]);

  const setRadioBtnValue = (e) => {
    // if (!isCAScreen) return;
    console.log("clicking Radio button",e.target.dataset.value )
    setImpactedTransaction(e.target.dataset.value);
    setStartDate("");
    setEndDate("");
    setTagId("");
    setVrn("");
    setTmsTxnId("");
    setGridData([]);
    rrnRef.current.value = "";
  };

  useEffect(() => {
    const headerjson = {
      plaza: userDetail.plaza
    };
    getPlaza(headerjson).then((res) => {
      // Convert, sort data for plaza dropdown
      const transformed = res.data.map(({ plazaId, plazaName }) => ({ value: plazaId, label: plazaId + "-" + plazaName.toLowerCase() }));
      transformed.sort((a, b) => a.value - b.value); // Sort plaza's based on plazaId
      transformed.unshift({ label: "All", value: "*" }); // Add 'All' value in dropdown
      //Set plaza list in state
      setTollPlaza(transformed);
      setPlaza(transformed.map(e => e.value));
    }).catch((_err) => { });
  }, [userDetail]);

  const searchImpactedTransaction = () => {
    if (!startDate) {
      validateFields('date', false);
      return;
    }
    if (plaza.length === 0) {
      validateFields('plaza', false);
      return;
    }
    const headerJson = {
      impactedTransaction,
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      tagId: tagId || "",
      vrn: vrn || "",
      tmsTxnId: tmsTxnId || "",
      rrn: rrnRef.current.value || "",
      field: tagId ? "tagId" : (vrn ? "vrn" : (tmsTxnId ? "tmsTxnId" : (rrnRef.current.value ? "rrn" : ""))),
      value: tagId ? tagId : (vrn ? vrn : (tmsTxnId ? tmsTxnId : (rrnRef.current.value ? rrnRef.current.value : "")))
    };
    const requestBody = {
      plazaIds: Array.isArray(plaza) ? plaza.join(",") : plaza
    };
    setLoading(true);
    //console.log(headerJson);
    getImpactedTransactionData(headerJson, requestBody, impactedTransaction).then(res => {
      //console.log(res);
      const transformedData = res.data.map(row => ({
        ...row,
        plazaName: (impactedTransaction === 'raiseNewViolation' || impactedTransaction === 'eligibleForDA')?  row.plazaName: `${row.plazaName.plazaDesc}`
      }));
      //console.log("ans",transformedData);
      setGridData(transformedData);
      setLoading(false);
    }).catch(_err => {
      console.log("error");
      setGridData([]);
      setLoading(false);
    });
  };

  const showHideRaisedViolationScreen = (rowData) => {
    const rrdtime = moment(rowData.readerReadTime).add(dateRangeMaxRange, 'days').format('YYYY MM DD HH:mm');
    const now = moment().format('YYYY MM DD HH:mm');
    if (rrdtime < now) {
      toast.warn("TAT Expired");
      return;
    }
    const headerJson = {
      tagId: rowData.tagId,
      readerReadTime: rowData.readerReadTime,
      vcClass: rowData.vcclass,
      impactedTransaction,
      rrn: rowData.rrn
    };
    validateViolationForRaisedDispute(headerJson, impactedTransaction).then(res => {
      if (res.message !== 'CaseId Already Present') {
        setDisputeDetails(rowData);
        //console.log("Details",rowData);
        setShowRaisedVioScreen(true);
      } else {
        toast.warning(res.message);
      }
    }).catch(err => {
      toast.warn(err.response?.data.message);
    });
  };

  return (
    <div className='impacted-trans-page'>
      <div className='trns-search-header'>
        <div>
          <p className='vio-head'>Search Impacted Transactions</p>
        </div>
        <div onClick={setRadioBtnValue}>
          <div data-value="raiseNewViolation" style={{ backgroundColor: '#ddf3e4', padding: '14px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
            <input type="radio" data-value="raiseNewViolation" name="impactedTransaction" checked={impactedTransaction === 'raiseNewViolation'} />
            <label data-value="raiseNewViolation">Raise New Violation</label>
          </div>
          {showEligibleforDA && <div data-value="eligibleForDA" style={{ backgroundColor: '#ddf3e4', padding: '14px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
            <input type="radio" data-value="eligibleForDA" name="impactedTransaction" checked={impactedTransaction === 'eligibleForDA'} />
            <label data-value="eligibleForDA">Raise New Violation: Eligible for DA</label>
          </div>}
          <div data-value="raiseRefund" style={{ backgroundColor: '#f2534b38', padding: '14px', width: 200, display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
            <input type="radio" data-value="raiseRefund" name="impactedTransaction" checked={impactedTransaction === 'raiseRefund'} disabled={!isCAScreen} />
            <label data-value="raiseRefund">Raise Refund</label>
          </div>
        </div>
      </div>

      <div className='trns-search-fields'>
        <div className='search-fields'>
          <div className='search-block'>
            <div className='flex input-filed' style={{ borderRight: '1px solid #707070' }}>
              <div className='label'>Date range<sup>*</sup></div>
              <div style={{ width: 240 }} className={!fields.date.valid ? "error-field" : ''}>
                <DateRangePickerComponent
                  startDate={startDate}
                  endDate={endDate}
                  format="MM/dd/yyyy"
                  max={new Date()}
                  min={new Date(moment(new Date()).subtract(dateRangeMaxRange, 'days'))}
                  onChange={(e) => setDate(e.target.value)} />
                {!fields.date.valid && <p className='invalid-field-message'>{fields.date.msg}</p>}
              </div>
            </div>

            <div className='flex input-filed'>
              <div className='label'>Tag ID </div>
              <div>
                <input type="text"
                  style={{ boxShadow: 'none' }}
                  maxLength={150}
                  className="form-control"
                  placeholder="Enter Tag ID"
                  value={tagId}
                  onChange={e => setTagId(e.target.value)}
                  autoComplete="off" />
              </div>
            </div>

            <div className='flex input-filed'>
              <div className='label'>VRN</div>
              <div>
                <input type="text"
                  style={{ boxShadow: 'none' }}
                  maxLength={150}
                  className="form-control"
                  placeholder="Enter VRN Number"
                  value={vrn}
                  onChange={e => setVrn(e.target.value)}
                  autoComplete="off" />
              </div>
            </div>
          </div>
          <div className='search-block'>
            <div className='flex input-filed' style={{ borderRight: '1px solid #707070' }}>
              <div className='label'>Plaza <sup>*</sup></div>
              <div className={(!fields.plaza.valid ? "error-field" : '') + " plazzalov"} style={{ width: 240 }}>
                <MultiSelect
                  options={tollPlazaData}
                  onChange={setPlazaIds}
                  selectedValue={plaza}
                />
                {!fields.plaza.valid && <p className='invalid-field-message'>{fields.plaza.msg}</p>}
              </div>
            </div>
            <div className='flex input-filed'>
              <div className='label'>TMS TXN ID </div>
              <div>
                <input type="text"
                  style={{ boxShadow: 'none' }}
                  maxLength={150}
                  className="form-control"
                  placeholder="Enter TMS TXN ID"
                  value={tmsTxnId}
                  onChange={e => setTmsTxnId(e.target.value)}
                  autoComplete="off" />
              </div>
            </div>

            <div className='flex input-filed'>
              <div className='label'>RRN</div>
              <div>
                <input type="text"
                  style={{ boxShadow: 'none' }}
                  maxLength={150}
                  className="form-control"
                  placeholder="Enter RRN Number"
                  ref={rrnRef}
                  autoComplete="off" />
              </div>
            </div>
          </div>
        </div>
        <div className="search-button">
          <div className='search-btn'>
            <Button variant="primary" onClick={searchImpactedTransaction}> Search {loading && <FaSpinner icon="spinner" spin className="spinner" />}</Button>
          </div>
        </div>
        {impactedTransaction === 'eligibleForDA' ? (
          <div className='search-fields-note'>
            Note: Search can happen with just Date, Plaza id as well as any one of these fields
          </div>
        ) : (
          <div className='search-fields-note'>
            Note : Search can happen with any one of these fields
          </div>
        )}
      </div>
      <p className='listing-title'>
        {impactedTransaction === 'eligibleForDA'
          ? 'Eligible for DA'
          : 'Impacted Transactions'}
      </p>
      <div className="impacted-trans-listing">
        <table>
          <thead>
            <tr>
              <th>VRN</th>
              <th>TMS Tnx ID</th>
              <th>Tag Id</th>
              <th>RRN</th>
              <th>Plaza Name</th>
              <th>Transaction Date &amp; Time</th>
              <th width={200}>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => (
                <tr key={index}>
                  <td>{row.vrn}</td>
                  <td>{row.tmsTxnId}</td>
                  <td>{row.tagId}</td>
                  <td>{row.rrn}</td>
                  <td>{row.plazaName}</td>
                  <td>
                    {row.txnDate
                      ? moment(row.txnDate).format("DD-MM-YYYY HH:mm:ss")
                      : "--"}
                  </td>
                  <td>
                    <button
                      className="raise_dispute_button"
                      onClick={() => showHideRaisedViolationScreen(row)}
                    >
                      {impactedTransaction === "raiseRefund"
                        ? "Raise Refund"
                        : "Raise Dispute"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} align="center">
                  No Transactions Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {gridData.length > 0 && gridData.length > itemsPerPage && impactedTransaction=="eligibleForDA" && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
        </div>
        )}
      </div>
      {
        showRaisedVioScreen &&
        <RaiseDisputeScreen
          setShowRaisedVioScreen={setShowRaisedVioScreen}
          disputeDetails={gridData}
          data={disputeDetails}
          impactedTransaction={impactedTransaction}
        />
      }
    </div>
  );
}